$(document).on("click", ".disciplineHeading", function () {
  $(this).next(".disciplineContent").toggle()
})
